// import Rx from 'rxjs/Rx'
// import {Observable} from 'rxjs'
import { Record } from 'immutable'
import { assign } from 'lodash'
// import Cookies from 'universal-cookie'
// import { INIT, LOADING, SUCCESS, ERROR } from '../../constants/phase'


// import { fromPromise } from 'rxjs/observable/fromPromise'
// import { of } from 'rxjs'
// import { mergeMap, flatMap, catchError } from 'rxjs/operators'
import { combineEpics } from 'redux-observable'

import * as api from './api'

/***********************************
 * Action Types
 ***********/
// const cookies = new Cookies()

export const FETCH_INVOICE_DELIVERY_DATA = 'empire/invoiceDelivery/FETCH_INVOICE_DELIVERY_DATA'
export const  FETCH_INVOICE_DELIVERY_BY_ID_DATA='empire/invoiceDelivery/FETCH_INVOICE_DELIVERY_BY_ID_DATA'
/***********************************
 * Initial State
 ***********/

// Unlike other ducks we are taking a class style approach
// for creating the InitialState. This is becuase we need to fetch the
// locally stored token in the constructor when it is created
const InitialStateInterface = {
  // We need this here to tell InitialState that there is a token key,
  // but it will be reset below to what is in localStorage, unless a value
  // is passed in when the object is instanciated
  data: {},
  token: null,
};

class InitialState extends Record(InitialStateInterface) {
  constructor(desiredValues) {
    // When we construct InitialState, we automatically update it's default value
    // for token to be what is stored in localStorage
    const token = '' // localStorage.getItem(Config.LocalStorageKeys.Authorization)
    super(assign({ token }, desiredValues))
  }
}

/***********************************
 * Reducer
 ***********/
// eslint-disable-next-line complexity, max-statements

export default function (state = new InitialState(), action = {}) {
  switch (action.type) {
    default: {
      return state
    }
  }
}


/***********************************
 * Action Creators
 ***********/

export const fetchInvoiceDeliveryData = data => {
  return {
    type: FETCH_INVOICE_DELIVERY_DATA,
    payload: api.getInvoiceDeliveryData(data)
  }
}
export const getInvoiceDeliveryByIdData = data => {
  return {
    type: FETCH_INVOICE_DELIVERY_BY_ID_DATA,
    payload: api.getInvoiceDeliveryByIdData(data)
  }
}


/***********************************
 * Epics
 ***********************************/


export const dashboardEpic = combineEpics()